import Vue from 'vue';
import Vuex from "vuex";
import { getStoreBuilder } from "vuex-typex";
import { GameState, Action, CardId } from './game';
import _ from 'lodash';
import { Client } from '@/client';
import { gameStore } from './game/store';

Vue.use(Vuex);

const rootBuilder = getStoreBuilder<RootState>();
export const rootModuleBuilder = rootBuilder.module("rootModule", {});

export const dispatchJoin = rootModuleBuilder.dispatch(async (ctx, { name, gid }: { name: string, gid: string | undefined }) => {
    const prom = new Promise((resolve, reject) => {
        const client = Client.getInstance(name, gid);
        client.onmessage = message => {
            const payload = <any>message;
            switch (message.action) {
                case Action.playerJoined:
                    gameStore.commitPlayerJoined(payload);
                    break;
                    case Action.playerLeft:
                        gameStore.commitPlayerLeft(payload);
                        break;
                case Action.gameStarted:
                    gameStore.commitGameStarted(payload);
                    break;
                case Action.nextTurn:
                    gameStore.commitNextTurn(payload);
                    break;
                case Action.getWitnessInfo:
                    gameStore.commitWitnessInfo(payload);
                    break;
                case Action.getInformantCard:
                    gameStore.commitInformantCard(payload);
                    break;
                case Action.accuse:
                    gameStore.commitAccuse(payload);
                    break;
                case Action.getPlayerGlass:
                    gameStore.commitGetPlayerGlass(payload);
                break;
                default:
                    break;
            };
        };
        client.onclose = (r) => {
            reject(r);
        };
        client.onopen = () => {
            client.send({
                action: Action.join
            });
        };
    });
    (<any>window).prom = prom;
    return prom;
}, "join");

export interface RootState {
    game: GameState
}

const stateGetter = rootModuleBuilder.state();
export const rootStore = {
    get state() { return stateGetter() },

    dispatchJoin
}


export const vuexStore = rootBuilder.vuexStore();

